import { Trans } from '@lingui/react'

import { ResendCounter } from './resend-counter'

type Props = {
  actionAvailableAt?: string
  setActionAvailable: (value: boolean) => void
  variant: 'sms' | 'email'
}
export const ResendButtonContent = ({
  actionAvailableAt,
  setActionAvailable,
  variant,
}: Props) =>
  variant === 'sms' ? (
    <Trans
      id="resendSmsButton.timer"
      values={{
        remaining: (
          <ResendCounter
            date={actionAvailableAt}
            onCompleted={() => setActionAvailable(true)}
          />
        ),
      }}
    />
  ) : (
    <Trans
      id="resendSmsButton.timer.email"
      values={{
        remaining: (
          <ResendCounter
            date={actionAvailableAt}
            onCompleted={() => setActionAvailable(true)}
          />
        ),
      }}
    />
  )
